type GetSearchResultDesktopCardSizeArgs = {
  enableStickyFilterBar?: boolean;
  coachOpen?: boolean;
};

// Grid column span (out of 12) for a search result card at the `lg` breakpoint.
export const getSearchResultDesktopCardSize = ({
  enableStickyFilterBar = false,
  coachOpen = false,
}: GetSearchResultDesktopCardSizeArgs): 3 | 4 => {
  if (coachOpen) return 4;
  return enableStickyFilterBar ? 3 : 4;
};

type GetSearchResultCardsPerRowArgs = {
  isLargeViewport: boolean;
  isMediumViewport: boolean;
  isSmallViewport: boolean;
  enableStickyFilterBar: boolean;
  coachOpen?: boolean;
};

export const getSearchResultCardsPerRow = ({
  isLargeViewport,
  isMediumViewport,
  isSmallViewport,
  enableStickyFilterBar,
  coachOpen,
}: GetSearchResultCardsPerRowArgs): number => {
  if (isLargeViewport) return 12 / getSearchResultDesktopCardSize({ enableStickyFilterBar, coachOpen });
  if (isMediumViewport) return 3;
  if (isSmallViewport) return 2;
  return 1;
};
